import React, { Fragment } from 'react'
import { Intro, SwipeCards, Voiceover } from 'cvs-core'
import img1 from '../../assets/images/U2-T1-1-8a.svg'
import img2 from '../../assets/images/U2-T1-1-8b.svg'
import img3 from '../../assets/images/U2-T1-1-8c.svg'
import img4 from '../../assets/images/U2-T1-1-8d.svg'
import voAudio from '../../assets/vo/CVS-HS-SPM-Learn-04-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Swipe through the cards to discover information about various resources you can rely upon if you or someone you know starts vaping and wants to stop.',
}

const data = [
  {
    image: img1,
    imageText: 'Human Resources',
    title: <span>Human Resources</span>,
    body:
      'You can always rely on human resources like parents, teachers, coaches, etc. You can suggest that friends talk with a trusted adult about their new habit, or you can go to a trusted adult yourself to get help handling the situation.',
  },
  {
    image: img2,
    imageText: 'Text Message Programs',
    title: <span>Text Message Programs</span>,
    body:
      'You can utilize anonymous and free text message programs like the age based “This is Quitting” program from the Truth Initiative which shows the reality of quitting – the easy and tough aspects – and provides a constant support network. SmokefreeTXT from smokefree.gov supports teens aged 13-17 who are ready to quit smoking.',
  },
  {
    image: img3,
    imageText: 'Specialized Apps',
    title: <span>Specialized Apps</span>,
    body:
      'Free apps like quitSTART gamify the quitting process to engage users with tailored tips, inspiration, and challenges.',
  },
  {
    image: img4,
    imageText: 'Professional Help',
    title: <span>Professional Help</span>,
    body:
      'It isn’t always possible to quit vaping alone or with the help of a teenage peer. Sometimes, a user needs to see their family physician or pediatrician for help, work with a counselor or professional cessation program, or seek hospitalization for withdrawal symptoms. In such cases, you can remain available as emotional support through the difficult process by letting your friend know that you’re there for them and available to talk whenever they need to.',
  },
]

export default {
  title: 'Resources for Living Vape Free',
  path: '/prepare/resources-for-living-vape-free',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Resources for Living Vape Free"
        lead="Swipe through the cards to discover information about various resources you can rely upon if you or someone you know starts vaping and wants to stop."
        direction="Swipe each card to advance."
      />
      <SwipeCards data={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/Resources.js